import { orderedValues } from '../orderedValues'

export const preventSubmission = (e) => {
    e.preventDefault()
}

export const setAllValuesToTouched = (formik) => {
    for (let value in formik.values) {
        formik.touched[value] = true
    }
}

export const scrollToFirstError = (formik, orderedValues) => {
    let errorsList = Object.keys(formik.errors)
    const firstError = orderedValues.filter((value) => { return formik.touched.hasOwnProperty(value) && formik.errors.hasOwnProperty(value) })[0]

    if (errorsList.length > 0) {
        try {
            window.scrollTo(
                {
                    left: 0,
                    top: document.getElementById(firstError).offsetTop - 100,
                    behavior: 'smooth'
                }
            )
        } catch (error) {
            console.log(error)
        }
    }
}

export const addSummaryBackLogic = (setShowSummary) => {
    window.history.pushState(null, '')
    window.onpopstate = (e) => {
        setShowSummary(false)
    }
}

export const removeSummaryBackLogic = (setShowSummary) => {
    window.removeEventListener('popstate', (e) => {
        setShowSummary(false)
    })
}

export const proceedToSummary = (values, setShowSummary) => {
    // dispatch(hideErrorModalAction())
    window.history.pushState({ summary: true }, '', window.location.href)
    window.sessionStorage.setItem('userInput', JSON.stringify(values))
    return setShowSummary(true)
}

export const checkFormForErrors = (e, noErrors, setErrorTofocus, setAllValuesToTouched, formik) => {
    preventSubmission(e)
    noErrors ? formik.handleSubmit(e) : setErrorTofocus(true);
    setAllValuesToTouched(formik);
    scrollToFirstError(formik, orderedValues);
}

export const assignPDFValues = (formik, dbFormSpec, formType, appContext) => {
    const userInput = formik.values;
    const sensitiveInfo = formik.values.sensitiveInfo
    const facilityList = formik.values.facilityList
    const infoToReleaseGroup = formik.values.infoToReleaseGroup
    const releaseMode = formik.values.releasemodePdf
    const proxyForm = formType === 'Representative';
    const patientForm = formType === 'Patient';
    const requestPurposeNumber = formik.values.requestPurposePdf
    const NYPOrg = dbFormSpec.facility.orgId.includes('7042') || dbFormSpec.facility.orgId.includes('7101') || dbFormSpec.facility.orgId.includes('7239')

    formik.setFieldValue('disclosurePurposeGroup', requestPurposeNumber === '1' ? NYPOrg ? 'Patient Request' : 'Personal Reasons' : requestPurposeNumber === '3' ? 'Continuation of Care' : requestPurposeNumber === '4' ? 'Insurance Purposes' : requestPurposeNumber === '5' ? 'Immunization' : requestPurposeNumber === '6' ? 'Legal Purposes' : requestPurposeNumber === '7' ? 'Employer Requirement' : formik.values.requestPurposePdf);

    patientForm && formik.setFieldValue('pdf_PAddress', `${formik.values.PAddress1} ${formik.values.PAddress2} ${formik.values.PCity} ${formik.values.PState} ${formik.values.PZip}`);
    proxyForm && formik.setFieldValue('RepName', `${formik.values.RepFName} ${formik.values.RepMName && formik.values.RepMName + ' '}${formik.values.RepLName}`);
    proxyForm && formik.setFieldValue('pdf_RepAddress', `${formik.values.RepAddress1} ${formik.values.RepAddress2} ${formik.values.RepCity} ${formik.values.RepState} ${formik.values.RepZip}`);
    proxyForm && formik.setFieldValue('pdf_rrelationship', formik.values.rrelationship);

    formik.setFieldValue('pdf_PName', `${formik.values.PFName} ${formik.values.PMName && formik.values.PMName + ' '}${formik.values.PLName}`);
    formik.setFieldValue('pdf_RAddress', `${formik.values.RAddress1} ${formik.values.RAddress2} ${formik.values.RCity} ${formik.values.RState} ${formik.values.RZip}`);
    formik.values.dosFrom1 && formik.values.dosTo1 && formik.setFieldValue('pdf_serviceDates', `${new Date(formik.values.dosFrom1).toLocaleDateString('en-US', { timeZone: 'UTC' })} - ${new Date(formik.values.dosTo1).toLocaleDateString('en-US', { timeZone: 'UTC' })}`);
    formik.setFieldValue('pdf_deliveryMethod', releaseMode === '2' ? 'Electronic copy of records' : releaseMode === '5' ? 'Mail Paper Records' : releaseMode === '7' ? 'CD/DVD' : (releaseMode === '3' || releaseMode === '12') ? 'Fax' : (releaseMode === '8') ? 'Connect Patient Portal' : `Pickup records at ${dbFormSpec.facility.pickupLocation}`);



    //Hardcoded nonsense.  This needs to be replaced by an auto generated hash table.
    let siHashMap = {
        "DRUG": "Drug and/or alcohol abuse diagnosis and/or treatment",
        "GENETIC": "Genetic Testing Information",
        "HIV": "HIV/AIDS Related Information",
        "PSY": "Psychological/Psychiatric conditions",
        "STD": "Sexually transmitted disease(s) diagnosis and/or testing",
        "GENETICS": "Genetic Screening Test Results ",
        "ETOH": "Alcohol and Drug Abuse Treatment Records",
        "MNT": "Details of Mental Health Diagnosis and/or Treatment provide by a Psychiatrist, Psychologist, Mental Health Clinical Nurse, or Licensed Mental Health Clinician (LMHC).",
        "SOC": "Confidential Communications with a Licensed Social Worker",
        "HEP": "Information related to diagnosis or treatment of Hepatitis",
        "PRG": "Information related to diagnosis or treatment of Pregnancy",
        "ABU": "Information related to spouse abuse and/or child abuse or neglect",
        "COU": "Information concerning family violence and/or Domestic Violence Victims' Counseling. ",
        "SAC": "Contain information regarding rape and/or Sexual Assault Counseling"
    };

    // make a hash map from the CustomSensitiveInfoList description. 
    let customSensitiveMap = dbFormSpec.CustomSensitiveInfoList ? dbFormSpec.CustomSensitiveInfoList.CheckBoxes.reduce(function (hashmap, items) {
        hashmap[items.id.toUpperCase()] = items.text;
        return hashmap;
    }, {}) : {};

    let sensitiveMap = sensitiveInfo.map((item) => {
        let itemID = item.toUpperCase();
        return customSensitiveMap[itemID] ? customSensitiveMap[itemID] : siHashMap[itemID] ? siHashMap[itemID] : item
    }).join(', ');

    formik.setFieldValue('pdf_sensitiveInfoList', sensitiveMap);

    (appContext.localValues && appContext.localValues.facilityList) ? formik.setFieldValue('pdf_facilitiesList', appContext.localValues.facilityList.join('   |   ')) : formik.setFieldValue('pdf_facilitiesList', facilityList.join(', '))

    // formik.setFieldValue('pdf_facilitiesList', facilityList.reduce((output, inputFacility)=>{
    //     let facilityValue = inputFacility.replace('inputAuthorize', '')

    //     for (let obj of dbFormSpec.release.facilities){
    //       if (facilityValue === obj.key) {
    //         if (output.length < 1) {
    //           return output + obj.value
    //         }
    //         else {
    //           return output + ', ' + obj.value
    //         }          
    //       }
    //     }
    // }, ''))

    formik.setFieldValue('pdf_releaseItemsList', infoToReleaseGroup.reduce((output, inputItem) => {

        for (let obj of dbFormSpec.release.items) {
            if (inputItem === obj.key) {
                if (output.length < 1) {
                    return output + obj.value
                }
                else {
                    return output + ' | ' + obj.value
                }
            }
        }
    }, '') + `${formik.values.txtotherrecords && ', ' + formik.values.txtotherrecords}`)

    // formik.setFieldValue('pdf_releaseItemsList', `...`)
    // formik.setFieldValue('pdf_doctorList', `...`)
}